import Vue from 'vue';
import Router from 'vue-router'

import store from './store/index'
import rotas from './modules/rotas'

import AutorizacaoRotas from './models/AutorizacaoRotas'

Vue.use(Router)

// Método utilizado no beforeEnter das rotas.
// Ele que decide se vai pode acessar ou não
export const somenteAutenticado = (to, from, next) => {
  if (store.getters['autenticacao/autenticado']) {
    if (to.meta.cargo) {
      if (AutorizacaoRotas.podeLiberarRota(to.meta.cargo)) {
        return next()
      }
    } else {
      return next()
    }
  }

  return next({ name: 'rota-login' })

  // store.getters['autenticacao/autenticado'] ? next() : next({
  //   name: 'rota-login',
  // })
}

// Método utilizado no beforeEnter das rotas.
// Ele que decide se vai pode acessar ou não
export const somenteNaoAutenticado = (to, from, next) => {
  !store.getters['autenticacao/autenticado'] ? next() : next({
    name: 'rota-dashboard',
  })
}

function carregaRotas() {
  let arrRotas = []
  rotas.forEach(rotaAtual => {
    const rotasFormatadas = rotaAtual.rotas.map(rota => (
      {
        path: rota.path,
        name: rota.name,
        component: rota.component,
        beforeEnter: rota.autenticado ? somenteAutenticado : somenteNaoAutenticado,
        meta: {
          layout: rota.layout,
          titulo: rota.titulo,
          cargo: rota.cargo,
        },
      }
    ))

    arrRotas = arrRotas.concat(rotasFormatadas)
  })

  return arrRotas
}

carregaRotas()

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: carregaRotas(),
})
